import { render, staticRenderFns } from "./MultiLineText.vue?vue&type=template&id=61b25e95&scoped=true"
import script from "./MultiLineText.vue?vue&type=script&lang=js"
export * from "./MultiLineText.vue?vue&type=script&lang=js"
import style0 from "./MultiLineText.vue?vue&type=style&index=0&id=61b25e95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b25e95",
  null
  
)

export default component.exports